module.exports = __webpack_public_path__ + "static/img/20002 (4).5403799.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20002 (4).webp
// module id = tywp
// module chunks = 14